<template>
  <div class="event">
    <div class="pay">
        <form class="app-pay-form">
          <div class="transaction-status">
            <slot v-if="status == 'bonus'">
              Aktif Bonusunuz mevcut iken çekim yapamazsınız.
            </slot>
            <slot v-if="status.bonus_deposit">
              Aktif Freebet bonusunuz mevcut iken yatırım yapamazsınız
              Freebet'inizi iptal ederek yatırım yapabilirsiniz.
              <span style="font-weight: bold; text-decoration: underline; cursor: pointer;" v-on:click="cancelFreebet">İptal Etmek İçin Tıklayın</span>
            </slot>
            <slot v-if="status == 'cash_reserve'">
              Aktif kasa çeviriminiz mevcut iken çekim yapamazsınız
            </slot>
            <slot v-if="status == 'payin_freebet'">
              Freebet kazancını kullanabilmek için yatırım yapmanız gerekmektedir.
            </slot>
            <slot v-if="status.pending">
                Talebiniz gönderildi ! lütfen sonuçlanana kadar bekleyiniz.
            </slot>
            <slot v-if="status == 'payin_discount'">
              <!-- Hesabınızda discount tanımlıdır yatırım yapabilmek için, hesap bakiyenizin {{ user.group.discount_payin_coefficient }} {{ $auth.user.info.currency }} tutarından küçük olması gerekmektedir. -->
            </slot>
          </div>
        </form>
    </div>
  </div>
</template>

<script>
export default {
	name: 'TransactionStatus',
	props: ['status'],
  computed:{
    user(){
      return this.$user();
    },
    user_detail(){
      return this.$user_detail();
    },
  },
	methods: {
		cancelFreebet(){
			axios.get('user/bonus/cancel')
			.then((response) => {
				if (response.data.status) {
          this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
				}
			})
			.catch((err) => {
			});
		}
	}
}
</script>